import { useEffect, useState } from "react";
import axiosInstance from "../axiosInstance";
import * as general from "./general";
import {
  fetchScreenHiddenColumns,
  saveScreenHiddenColumns,
  normalizeOrderScreenHiddenColumns,
} from "./screenColumnPreference";

/**
 * Tải / đồng bộ cài đặt ẩn cột theo user + màn hình (server).
 * @param {string} screenKey
 * @param {{ key: string, label: string }[]} columns — định nghĩa cột hợp lệ của màn hình
 * @param {{ legacyLocalStorageKey?: string }} [options]
 */
export function useScreenColumnPreferences(screenKey, columns, options = {}) {
  const { legacyLocalStorageKey } = options;
  const [hiddenCols, setHiddenCols] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      let cols = await fetchScreenHiddenColumns(axiosInstance, screenKey, columns);

      if (!cols.length && legacyLocalStorageKey) {
        let legacy = general.getLocalStorage(legacyLocalStorageKey);
        if (!legacy?.length) legacy = [];
        legacy = normalizeOrderScreenHiddenColumns(legacy);
        const validKeys = new Set((columns || []).map((c) => c.key));
        const migrated = legacy.filter((k) => validKeys.has(k));
        if (migrated.length) {
          cols = migrated;
          try {
            await saveScreenHiddenColumns(axiosInstance, screenKey, migrated, columns);
          } catch {
            /* giữ local nếu lưu server thất bại */
          }
        }
      }

      if (!cancelled) {
        setHiddenCols(normalizeOrderScreenHiddenColumns(cols));
        setLoaded(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [screenKey, columns, legacyLocalStorageKey]);

  return { hiddenCols, setHiddenCols, loaded };
}
